import {
  SHARED_STROKE_WIDTH_MAX,
  SHARED_STROKE_WIDTH_MIN,
} from "@/lib/canvas/shared-shape";

/**
 * Stroke-width slider — themed range input shared by both surfaces.
 *
 * Bound to [2, 10] integer per `SHARED_STROKE_WIDTH_*`. The "W" label
 * mirrors the legacy tactical-board tool row.
 */

export type StrokeWidthSliderProps = {
  value: number;
  onChange: (width: number) => void;
  label?: string;
};

export function StrokeWidthSlider(props: StrokeWidthSliderProps) {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-baseline justify-between">
        <span className="text-xs font-display text-ink-muted uppercase tracking-wider">
          {props.label ?? "Stroke"}
        </span>
        <span
          className="text-sm font-mono text-ink"
          data-canvas-stroke-width={props.value}
        >
          {props.value}
        </span>
      </div>
      <input
        type="range"
        min={SHARED_STROKE_WIDTH_MIN}
        max={SHARED_STROKE_WIDTH_MAX}
        step={1}
        value={props.value}
        onChange={(e) => props.onChange(parseInt(e.target.value, 10))}
        aria-label="Stroke width"
        data-canvas-stroke-slider
        className="tktic-range w-full"
      />
    </div>
  );
}
